import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { FaBox, FaList, FaUpload, FaFileImport, FaFolderOpen, FaUsersCog, FaCog, FaSignOutAlt, FaExternalLinkAlt, FaUsers } from 'react-icons/fa';

function AdminLayout({ children }) {
  const { user, logout } = useAuth();
  const location = useLocation();

  const navItems = [
    { to: '/admin', icon: FaBox, label: 'Dashboard', exact: true },
    { to: '/admin/resources', icon: FaList, label: 'Resources' },
    { to: '/admin/resources/new', icon: FaUpload, label: 'Add Resource' },
    { to: '/admin/import', icon: FaFileImport, label: 'Import' },
    { to: '/admin/categories', icon: FaFolderOpen, label: 'Categories' },
  ];

  if (['admin', 'editor'].includes(user?.role)) {
    navItems.push({ to: '/admin/visitors', icon: FaUsers, label: 'Visitors' });
  }
  if (user?.role === 'admin') {
    navItems.push({ to: '/admin/users', icon: FaUsersCog, label: 'Users' });
    navItems.push({ to: '/admin/settings', icon: FaCog, label: 'Settings' });
  }

  const isActive = (item) => {
    if (item.exact) return location.pathname === item.to;
    return location.pathname.startsWith(item.to);
  };

  return (
    <div className="admin-layout">
      <aside className="admin-sidebar">
        <div className="admin-sidebar-header">
          <div className="admin-brand">
            <span className="admin-brand-icon">G</span>
            <div className="admin-brand-info">
              <h3>GGLANCC</h3>
              <span className="admin-brand-sub">Admin Panel</span>
            </div>
          </div>
        </div>

        <div className="admin-user-card">
          <div className="admin-avatar">
            {user?.username?.charAt(0).toUpperCase()}
          </div>
          <div className="admin-user-details">
            <span className="admin-username">{user?.username}</span>
            <span className="role-badge">{user?.role}</span>
          </div>
        </div>

        <nav className="admin-nav">
          <div className="admin-nav-label">Menu</div>
          {navItems.map(item => (
            <Link
              key={item.to}
              to={item.to}
              className={`admin-nav-item ${isActive(item) ? 'active' : ''}`}
            >
              <item.icon className="admin-nav-icon" />
              <span>{item.label}</span>
            </Link>
          ))}

          <div className="admin-nav-divider" />
          <a href="/" target="_blank" rel="noreferrer" className="admin-nav-item">
            <FaExternalLinkAlt className="admin-nav-icon" />
            <span>View Site</span>
          </a>
          <button onClick={logout} className="admin-nav-item admin-logout">
            <FaSignOutAlt className="admin-nav-icon" />
            <span>Logout</span>
          </button>
        </nav>
      </aside>
      <main className="admin-main">{children}</main>
    </div>
  );
}

export default AdminLayout;
